import { ConfigApi, FetchApi } from '@backstage/core-plugin-api';
import {
  BackstageAdoptionApi,
  BackstageAdoptionDto,
} from './BackstageAdoptionApi';

/**
 * Reads the Backstage documentation adoption data from the IMC API.
 *
 * The base URL is the same IMC host used by the score-card plugin
 * (`scorecards.jsonDataUrl`), with the path `/api/imc/v1/backstage-adoption`.
 * It is configured via `backstageAdoption.apiUrl`.
 */
export class BackstageAdoptionClient implements BackstageAdoptionApi {
  private readonly configApi: ConfigApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { configApi: ConfigApi; fetchApi: FetchApi }) {
    this.configApi = options.configApi;
    this.fetchApi = options.fetchApi;
  }

  async getAll(): Promise<BackstageAdoptionDto[]> {
    const url = this.configApi.getString('backstageAdoption.apiUrl');
    const response = await this.fetchApi.fetch(url);
    if (!response.ok) {
      throw new Error(
        `Request failed: ${response.status} ${response.statusText}`,
      );
    }
    return response.json();
  }
}
